import { boolean, mixedObj, slider, object, constraints } from "./helpers";
import { DeviceSettingOptions } from "./settingOptions";
import { Video } from "./types";

export const video = object<Video>({
  brightness: object({
    value: slider("BRIGHTNESS"),
    constraints: constraints()
  }),
  contrast: object({ value: slider("CONTRAST"), constraints: constraints() }),
  hue: object({ value: slider("HUE"), constraints: constraints() }),
  saturation: object({
    value: slider("SATURATION"),
    constraints: constraints()
  }),
  sharpness: object({ value: slider("SHARPNESS"), constraints: constraints() }),
  gamma: object({ value: slider("GAMMA"), constraints: constraints() }),
  focus: object({ value: slider("FOCUS"), constraints: constraints() }),
  focus_auto_enabled: object({
    value: boolean(""),
    constraints: constraints()
  }),
  white_balance: object({
    value: slider("WHITE_BALANCE"),
    constraints: constraints()
  }),
  white_balance_auto_enabled: object({
    value: boolean(""),
    constraints: constraints()
  }),
  back_light_compensation: object({
    value: slider("BACK_LIGHT_COMPENSATION"),
    constraints: constraints()
  }),
  gain: object({ value: slider("GAIN"), constraints: constraints() }),
  zoom: object({ value: slider("ZOOM"), constraints: constraints() }),
  exposure: object({ value: slider("EXPOSURE"), constraints: constraints() }),
  exposure_auto_enabled: object({
    value: boolean(""),
    constraints: constraints()
  }),
  skin_enhancement: object({
    value: boolean("SKIN_ENHANCEMENT"),
    constraints: constraints()
  }),
  wide_dynamic_range: object({
    value: boolean("WIDE_DYNAMIC_RANGE"),
    constraints: constraints()
  }),
  participant_count: object({
    value: boolean("PARTICIPANT_COUNT"),
    constraints: constraints()
  }),
  onscreen_display: object({
    value: boolean("ONSCREEN_DISPLAY"),
    constraints: constraints()
  }),
  tracking_speed: object({
    value: mixedObj(DeviceSettingOptions.trackingSpeedOpts, "TRACKING_SPEED")
  }),
  tracking_mode: object({
    value: mixedObj(DeviceSettingOptions.trackingModeOpts, "TRACKING_MODE")
  }),
  anti_flicker: object({
    value: mixedObj(DeviceSettingOptions.antiFlickerOpts, "ANTI_FLICKER")
  }),
  frame_size: object({
    value: mixedObj(DeviceSettingOptions.frameSizeOpts, "FRAME_SIZE")
  }),
  max_zoom: object({
    value: mixedObj(DeviceSettingOptions.maxZoomOpts, "MAX_ZOOM")
  }),
  camera_movement: object({
    value: mixedObj(DeviceSettingOptions.cameraMovementOpts, "CAMERA_MOVEMENT")
  })
}).required();
